import keycloakClient from "@keycloak/keycloak";
import { BACKEND_API_URL } from "../../config";
import { SummaryResponse } from "./models";

class SummaryService {
  private readonly baseUrl: string;

  constructor(baseUrl: string) {
    this.baseUrl = baseUrl;
  }

  /**
   * Obtiene las cabeceras de autenticación
   */
  private getAuthHeaders(): HeadersInit {
    return {
      Authorization: `Bearer ${keycloakClient.token}`,
      Accept: "application/json",
      "Content-Type": "application/json"
    };
  }

  private handleApiError(error: any): never {
    console.error("Error en la comunicación con el API de resumen:", error);
    throw error;
  }

  async generateSummary(
    sessionId: string,
    language: string
  ): Promise<SummaryResponse> {
    try {
      const response = await fetch(
        `${this.baseUrl}/summary/${sessionId}?language=${language}`,
        {
          method: "GET",
          headers: this.getAuthHeaders()
        }
      );

      if (!response.ok) {
        throw new Error(
          `Error al solicitar resumen: ${response.status} ${response.statusText}`
        );
      }

      return (await response.json()) as SummaryResponse;
    } catch (error) {
      return this.handleApiError(error);
    }
  }
}

// Instancia del servicio
export const summaryService = new SummaryService(
  `${BACKEND_API_URL}/siren-back/v1`
);
